import * as ROUTES from '../routes';
import { match, routeWithContext } from '../../lib/route.utils';
import { PERMISSIONS } from '../authentication/permissions';
import { accessToClearance, accessToPerformance } from '../../selectors/authentication';

export const SIDEBAR = [
    {
        label: 'Organizations',
        to: s => routeWithContext(s, ROUTES.ADMIN_ORGS_PATH, ROUTES.ADMIN_ORG_DETAILS_PATH),
        highlight: current =>
            match(current, ROUTES.ADMIN_ROOT_PATH, ROUTES.ADMIN_ORGS_PATH, ROUTES.ADMIN_ORG_DETAILS_PATH),
        noContext: true,
        requiredPermission: PERMISSIONS.GOD,
        requiredPermissionAll: PERMISSIONS.ORGANIZATIONS_VIEW_ALL
    },
    {
        label: 'Events',
        to: s => routeWithContext(s, ROUTES.ADMIN_EVENTS_PATH, ROUTES.ADMIN_ORG_EVENTS_PATH),
        highlight: current =>
            match(
                current,
                ROUTES.ADMIN_EVENTS_PATH,
                ROUTES.ADMIN_ORG_EVENTS_PATH,
                ROUTES.ADMIN_EVENTS_NEW_PATH,
                ROUTES.ADMIN_ORG_EVENTS_NEW_PATH,
                ROUTES.ADMIN_ORG_EVENTS_DETAILS_PATH,
                ROUTES.ADMIN_EVENTS_DETAILS_PATH
            ),
        requiredPermission: PERMISSIONS.EVENTS_VIEW,
        requiredPermissionAll: PERMISSIONS.GOD
    },
    {
        label: 'Contacts',
        to: s => routeWithContext(s, ROUTES.ADMIN_CONTACTS_PATH, ROUTES.ADMIN_ORG_CONTACTS_PATH),
        highlight: current =>
            match(
                current,
                ROUTES.ADMIN_CONTACTS_PATH,
                ROUTES.ADMIN_ORG_CONTACTS_PATH,
                ROUTES.ADMIN_CONTACTS_NEW_PATH,
                ROUTES.ADMIN_ORG_CONTACTS_NEW_PATH,
                ROUTES.ADMIN_CONTACTS_DETAILS_PATH,
                ROUTES.ADMIN_ORG_CONTACTS_DETAILS_PATH
            ),
        requiredPermission: PERMISSIONS.CONTACTS_VIEW,
        requiredPermissionAll: PERMISSIONS.CONTACTS_VIEW_ALL
    },
    {
        label: 'Artists',
        to: s => routeWithContext(s, ROUTES.ADMIN_ARTISTS_PATH, ROUTES.ADMIN_ORG_ARTISTS_PATH),
        highlight: current =>
            match(
                current,
                ROUTES.ADMIN_ARTISTS_PATH,
                ROUTES.ADMIN_ORG_ARTISTS_PATH,
                ROUTES.ADMIN_ARTISTS_NEW_PATH,
                ROUTES.ADMIN_ORG_ARTISTS_NEW_PATH,
                ROUTES.ADMIN_ORG_ARTISTS_DETAILS_PATH,
                ROUTES.ADMIN_ARTISTS_DETAILS_PATH
            ),
        requiredPermission: PERMISSIONS.ARTISTS_VIEW,
        requiredPermissionAll: PERMISSIONS.ARTISTS_VIEW_ALL
    },
    {
        label: 'Media Partners',
        to: s => routeWithContext(s, ROUTES.ADMIN_PARTNERS_PATH, ROUTES.ADMIN_ORG_PARTNERS_PATH),
        highlight: current =>
            match(
                current,
                ROUTES.ADMIN_PARTNERS_PATH,
                ROUTES.ADMIN_ORG_PARTNERS_PATH,
                ROUTES.ADMIN_PARTNERS_NEW_PATH,
                ROUTES.ADMIN_ORG_PARTNERS_NEW_PATH,
                ROUTES.ADMIN_ORG_PARTNERS_DETAILS_PATH,
                ROUTES.ADMIN_PARTNERS_DETAILS_PATH
            ),
        requiredPermission: PERMISSIONS.PARTNERS_VIEW,
        requiredPermissionAll: PERMISSIONS.PARTNERS_VIEW_ALL
    },
    {
        label: 'Contracts',
        to: s => routeWithContext(s, ROUTES.ADMIN_CONTRACTS_PATH, ROUTES.ADMIN_ORG_CONTRACTS_PATH),
        highlight: current =>
            match(
                current,
                ROUTES.ADMIN_CONTRACTS_PATH,
                ROUTES.ADMIN_ORG_CONTRACTS_PATH,
                ROUTES.ADMIN_CONTRACTS_NEW_PATH,
                ROUTES.ADMIN_ORG_CONTRACTS_NEW_PATH,
                ROUTES.ADMIN_ORG_CONTRACTS_DETAILS_PATH,
                ROUTES.ADMIN_CONTRACTS_DETAILS_PATH,
                ROUTES.ADMIN_TEMPLATES_NEW_PATH,
                ROUTES.ADMIN_ORG_TEMPLATES_NEW_PATH,
                ROUTES.ADMIN_TEMPLATES_DETAILS_PATH,
                ROUTES.ADMIN_ORG_TEMPLATES_NEW_PATH
            ),
        requiredPermission: PERMISSIONS.CONTRACTS_VIEW,
        requiredPermissionAll: PERMISSIONS.GOD,
        permissionFunction: (user, contextSubject) =>
            accessToClearance(user, contextSubject) || accessToPerformance(user, contextSubject)
    }
];
